import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeEntryCategoryComponent } from './time-entry-category/time-entry-category.component';
import { SharedModule } from '../shared/shared.module';
import { TimeEntriesComponent } from './time-entries/time-entries.component';
import { TimeReportComponent } from './time-entries/time-report/time-report.component';
import { TimeEvaluationComponent } from './time-entries/time-evaluation/time-evaluation.component';
import { MyTimeComponent } from './my-time/my-time.component';
import { MyTimeReportingComponent } from './my-time/my-time-reporting/my-time-reporting.component';
import { MyAbsencesComponent } from './my-time/my-absences/my-absences.component';
import { MyTimeTrackingComponent } from './my-time/my-time-tracking/my-time-tracking.component';
import { AbsencesComponent } from './absences/absences.component';
import { AllAbsencesComponent } from './absences/all-absences/all-absences.component';
import { AbsenceReviewComponent } from './absences/absence-review/absence-review.component';
import { DayReportsComponent } from './time-entries/day-reports/day-reports.component';



@NgModule({
  declarations: [
    TimeEntryCategoryComponent,
    TimeEntriesComponent,
    MyTimeTrackingComponent,
    TimeReportComponent,
    TimeEvaluationComponent,
    MyTimeComponent,
    MyTimeReportingComponent,
    MyAbsencesComponent,
    AbsencesComponent,
    AllAbsencesComponent,
    AbsenceReviewComponent,
    DayReportsComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class TimeTrackingModule { }
